import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
    connect() {
        this.selectElement = this.element.querySelector('select');

        if (!this.selectElement.tomselect) {
            const plugins = ['clear_button'];

            if (this.selectElement.hasAttribute('multiple')) {
                plugins.push('remove_button');
            }

            this.select = new TomSelect(this.selectElement, {
                plugins: plugins,
                maxOptions: null,
                create: false,
                render: {
                    option: (data) => {
                        return `<div>` + data.text + `</div>`;
                    },
                    item: (data) => {
                        return `<div>` + data.text + `</div>`;
                    },
                },
            });
        }
    }
}
